import { atom, useRecoilState } from 'recoil';

type NavProductData = {
    price: number;
    title: string;
    available: 0 | 1 | 2;
};

export const navProductDataState = atom<NavProductData>({
    key: 'navProductDataState',
    default: {
        price: 0,
        title: '',
        available: 0,
    },
});

export const useNavProductDataState = () => useRecoilState(navProductDataState);
